import { Service } from "../decorators/service.decorator";

@Service()
export class NotificationFactory {

  create(type, title, text) {
    const notificationEl = document.createElement('cc-notification');

    notificationEl.setAttribute('type', type);

    if (title) {
      notificationEl.setAttribute('title', title);
    }

    if (text) {
      notificationEl.setAttribute('text', text);
    }

    return notificationEl;
  }
}
